/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Text, Space } from '@cashfree-intl/coherent';

import { CURRENCY_SYMBOL } from 'utils/constants';
import {
  isICICIDashboard,
  isLKDashboard,
  numberWithCommas,
} from 'utils/common';

import onDemandActivation from '../../../videos/on-demand-activation.mp4';
import iciciondemand from '../../../videos/icici-od-settlements.mp4';
import lendingkartondemand from '../../../videos/lendingkart-od-settlements.mp4';
import odsettlementsbg from '../../../images/pitch-page-banner.svg';
import odsettlementslendingkartbg from '../../../images/lendingkart-pitch-banner-bg.png';
import odsettlementsicicibg from '../../../images/icici-pitch-banner-bg.png';
import freetrialpitchbannerbg from '../../../images/free-trial-pitch-banner-bg.svg';

import CustomIcon from '../../../components/CustomIcons';
// will be used for idfc
// import odsettlementsidfcbg from '../../../images/idfc-pitch-banner-bg.png';

const computeAssets = () => {
  if (isICICIDashboard()) {
    return {
      backgroundImage: odsettlementsicicibg,
      bannerVideo: iciciondemand,
    };
  }
  if (isLKDashboard()) {
    return {
      backgroundImage: odsettlementslendingkartbg,
      bannerVideo: lendingkartondemand,
    };
  }
  return {
    backgroundImage: odsettlementsbg,
    bannerVideo: onDemandActivation,
  };
};

function OnDemandBanner({ requestActivation, freeTrialConstants }) {
  const { backgroundImage, bannerVideo } = computeAssets();

  const styleProps = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };

  const list = [
    'Request settlements when needed',
    'Ensure adequate cash flow',
    `Charges of ${
      freeTrialConstants.odDefaultRate
    }% of the settlement + GST applicable`,
  ];

  return (
    <div className="on-demand-banner-wrapper">
      <div className="on-demand-banner mb-3" style={styleProps}>
        <div className="banner-text">
          {/* <div className="heading-text">On-Demand Settlements</div> */}
          <Text variant="h28" color="white" className="w-600">
            On-Demand Settlements
          </Text>
          {freeTrialConstants && freeTrialConstants.odDefaultLimit && (
            <Space alignItems="center" className="mt-1">
              <Space alignItems="center">
                <CustomIcon componentName="GREEN_TICK" />
                <Text variant="b14" color="white" className="ml-1">
                  Pre-approved daily limit of {CURRENCY_SYMBOL.INR}{' '}
                  {numberWithCommas(freeTrialConstants.odDefaultLimit)}
                </Text>
              </Space>
              <div className="horizontal-divider mx-1 my-0" />
              <Space alignItems="center">
                <CustomIcon componentName="GREEN_TICK" />
                <Text variant="b14" color="white" className="ml-1">
                  Get maximum daily limit after approval
                </Text>
              </Space>
            </Space>
          )}
          <Text variant="h16" color="white" className="mt-2 mb-3">
            With On-Demand settlements, you can request settlements <br /> on
            any day and at any time 24*7, including holidays.
          </Text>
          {list.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Space gap={1} key={index} className="mb-1" alignItems="center">
              <img
                src="https://cashfreelogo.cashfree.com/website/pg/od-settlements-assets/stars-group.svg"
                alt="stars-group"
              />
              <Text variant="b14" color="white">
                {item}
              </Text>
            </Space>
          ))}
        </div>
        {/* <img src={bannerGif} alt="Settlements On-Demand" />
         */}
        <video autoPlay loop muted>
          <source src={bannerVideo} type="video/mp4" />
        </video>
      </div>
      <div
        className="p-4 free-trial-banner"
        style={{
          ...styleProps,
          backgroundImage: `url(${freetrialpitchbannerbg})`,
        }}
      >
        <Space alignItems="center" justifyContent="space-between">
          <Space alignItems="center" gap={3}>
            <CustomIcon componentName="EXCLUSIVE_ACCESS" />
            <div>
              <Text variant="h28" className="w-600">
                Activate Now and Withdraw for Free
              </Text>
              <Text variant="h16" className="mt-2 mb-2">
                Try <span className="w-600">On-Demand Settlements</span> for
                free and enjoy exclusive access to:
              </Text>
              {/* add the 3 meta data here */}
              <Space
                wrap="wrap"
                alignItems="center"
                className="banner-meta-data"
              >
                <Space alignItems="center" className="banner-meta-data-item">
                  <img
                    src="https://cashfreelogo.cashfree.com/website/pg/od-settlements-assets/stars-group.svg"
                    alt="stars-group"
                  />
                  <Text variant="h16" color="focused">
                    <span>{freeTrialConstants.odFreeTrialEligibleCount}</span>{' '}
                    Free Trials
                  </Text>
                </Space>
                <Space alignItems="center" className="banner-meta-data-item">
                  <img
                    src="https://cashfreelogo.cashfree.com/website/pg/od-settlements-assets/stopwatch.svg"
                    alt="stopwatch"
                  />
                  <Text variant="h16" color="focused">
                    <span>{freeTrialConstants.odFreeTrialEligibleDays}</span>{' '}
                    Days Validity
                  </Text>
                </Space>
                <Space alignItems="center" className="banner-meta-data-item">
                  <img
                    src="https://cashfreelogo.cashfree.com/website/pg/od-settlements-assets/rupee.svg"
                    alt="rupee"
                  />
                  <Text variant="h16" color="focused">
                    upto ₹{' '}
                    <span>
                      {numberWithCommas(
                        freeTrialConstants.odFreeTrialEligibleAmount,
                      )}
                    </span>{' '}
                    Worth Settlements
                  </Text>
                </Space>
              </Space>
            </div>
          </Space>
          <Button
            primary
            onClick={requestActivation}
            data-event-name="Primary_Button_ActivateNow"
          >
            Activate Now
          </Button>
        </Space>
      </div>
    </div>
  );
}

OnDemandBanner.propTypes = {
  requestActivation: PropTypes.func.isRequired,
  freeTrialConstants: PropTypes.object,
};

export default OnDemandBanner;
